import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  toggle: {
    marginTop: 24,
    '& .MuiTypography-root': {
      color: theme.palette.common.black,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  field: {
    width: 200,
    '& textarea': {
      height: '60px !important',
    },
  },
  fieldContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  fieldSeparatorContainer: {
    margin: '0 32px',
    paddingBottom: 23,
  },
  fieldSeparatorIcon: {
    color: theme.palette.secondary.dark,
    width: 20,
  },
}))
